module.exports = __webpack_public_path__ + "static/media/ionic.a3d4ba83.png";